import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingState = ({ label = 'Carregando...', description, size = 'md', mode = 'section', className = '' }) => (
  <div role="status" aria-live="polite" aria-busy="true"
    className={`flex items-center justify-center gap-3 text-center ${mode === 'inline' ? 'flex-row py-2' : 'flex-col px-4 py-8'} ${mode === 'page' ? 'min-h-[70vh]' : ''} ${className}`}>
    <Loader2 aria-hidden="true" className={`animate-spin motion-reduce:animate-none text-blue-600 dark:text-blue-400 ${size === 'sm' ? 'h-4 w-4' : size === 'lg' ? 'h-9 w-9' : 'h-6 w-6'}`} />
    <div className="grid gap-1">
      {label && <p className="text-lg font-bold text-gray-900 dark:text-gray-100">{label}</p>}
      {description && <p className="max-w-lg text-sm text-gray-500 dark:text-gray-400">{description}</p>}
    </div>
  </div>
);
export default LoadingState;
